import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import PageviewIcon from '@material-ui/icons/Pageview';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { styleTextLink } from "../../../utils/style";
import Link from '@material-ui/core/Link';
import ListAltIcon from '@material-ui/icons/ListAlt';
import imageLoading from '../../../assets/loading.gif';
import errorImg from '../../../assets/error.png';
import passImg from '../../../assets/pass.png';
import * as alertDialog from "../../../utils/alert";

function jobFormatter(row) {

  if (row.IS_VALID === 0) {
    return (
      <img src={imageLoading} style={{ marginLeft: '1px' }} alt="Loading" width="20" height="20" />
    );
  } else if (row.IS_VALID === 2) {
    return (
      <Link
        component="button"
        variant="body2"
        onClick={() => {
          alertDialog.ErrorDialogSQL(row.ERROR_MESSAGE);
        }}
      >
        <img src={errorImg} style={{ marginLeft: '1px' }} alt="Error validate script failed." width="20" height="20" />

      </Link>
    );
  } else {
    return (
      <img src={passImg} style={{ marginLeft: '1px' }} alt="Loading" width="20" height="20" />
    );
  }
}

export const getViewColumns = (downLoadFile, ViewDetail, ViewHistory, sortTable) => {
  const columns = [
    {
      dataField: "DID",
      text: "Edit",
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <ListAltIcon
              color="action"
              onClick={() => {
                ViewDetail(row.JOB_GUID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "JOB_ID",
      text: "ID",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "JOB_NAME",
      text: "Job Name",
      sort: sortTable,
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <span>
            <Link
              component="button"
              variant="body2"
              onClick={() => {
                ViewHistory(row.JOB_GUID);
              }}
            >
              {row.JOB_NAME}

            </Link>
          </span>
        )
      }
    },
    {
      dataField: "Verify",
      text: "Verify  ",
      sort: false,
      headerAlign: 'center',
      align: 'center',
      headerStyle: (colum, colIndex) => {
        return { minWidth: '25px', width: '25px',marginRight: '5px' , textAlign: 'center' };
      },
      formatter: (cell, row) => {
        return (
          jobFormatter(row)
        )
      }
    },
    {
      dataField: "SCHEDULE_TYPE",
      text: "Schedule Type",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "START_DATE",
      text: "Start Date",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.START_DATE)}</>;
      },
    },
    {
      dataField: "END_DATE",
      text: "End Date",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.END_DATE)}</>;
      },
    },
    {
      dataField: "UPDATE_DATE",
      text: "Last Execution Date",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.UPDATE_DATE)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Job Status",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },

    {
      dataField: "DownLoadID",
      text: "Download",
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            {(row.ISDOWNLOAD === "1") ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  downLoadFile(row.EXEC_NO);
                }}
              />

            ) : row.TEXT_DOWNLOAD}
          </Box>
        );
      },
    },
  ];
  return columns;
};
export const getHistoryColumns = (Download, sortTable) => {
  const columns = [
    // {
    //   dataField: "TALEND_TASK_ID",
    //   text: "Task ID",
    //   sort: sortTable,
    //   headerAlign: 'center',
    //   align: 'center',
    // },
    {
      dataField: "EXEC_NO",
      text: "EXEC ID",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SCHEDULE_TIME",
      text: "Date",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.SCHEDULE_TIME)}</>;
      },
    },
    {
      dataField: "DATE_TIME_START",
      text: "Start Time",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
    },
    {
      dataField: "DATE_TIME_END",
      text: "End Time",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
    },
    {
      dataField: "STATUS",
      text: "Status",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: sortTable,
      headerAlign: 'center',
    },
    {
      dataField: "EXECUTION_TIME",
      text: "Execution Time(Sec)",
      sort: sortTable,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DID",
      text: "Download",
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            {(row.ISDOWNLOAD === "1") ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  Download(row.EXEC_NO);
                }}
              />

            ) : row.TEXT_DOWNLOAD}
          </Box>
        );
      },
    },

  ];
  return columns;
};
